import { getString } from '../../../constants/Strings';
import { updateBillingAddress, updateFormFieldData } from '../../../redux/PaymentState/PaymentState.actions';
import { PaymentFormDataFields, PaymentFormValidationFields } from '../constants';
import { getPaymentFieldErrorText } from './getPaymentFieldErrorText';
import { doFireStatusUpdate } from '../../../utils/CallbackUtils';

/**
 * Util to handle Address Update command from User address
 * @param statusUpdate
 * @param dispatchAddressUpdate
 * @param dispatch
 * @param ui
 * @param paymentForm
 * @param paymentErrorModal
 */
export var handleAddressUpdate = function handleAddressUpdate(params) {
  var statusUpdate = params.statusUpdate,
    dispatch = params.dispatch,
    paymentForm = params.paymentForm,
    paymentErrorModal = params.paymentErrorModal;
  var _ref = statusUpdate.payload.data,
    zip = _ref.zip,
    country = _ref.country,
    selectedCity = _ref.selectedCity;

  // eslint-disable-next-line camelcase
  var city = selectedCity.city,
    state_abbreviation = selectedCity.state_abbreviation,
    state = selectedCity.state;
  var value = zip.value,
    isMandatory = zip.isMandatory;
  dispatch(updateBillingAddress({
    city: city,
    // eslint-disable-next-line camelcase
    state: state_abbreviation || state,
    zip: value,
    country: country.countryCode,
    isZipMandatory: isMandatory
  }));
  dispatch(updateFormFieldData({
    userAddress: {
      error: hasAddressErrors(statusUpdate, paymentForm, paymentErrorModal)
    }
  }));
  doFireStatusUpdate([statusUpdate]);
};
export var hasAddressErrors = function hasAddressErrors(statusUpdate, paymentForm, paymentErrorModal) {
  var payload = statusUpdate.payload;
  var _ref2 = payload.data,
    _ref2$zip = _ref2.zip,
    error = _ref2$zip.error,
    invalid = _ref2$zip.invalid,
    country = _ref2.country;
  if (error) return error;
  if (invalid) return invalid;
  if (country.error) return getPaymentFieldErrorText({
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    error: PaymentFormDataFields.INVALID_COUNTRY,
    requiredKey: '',
    invalidKey: PaymentFormValidationFields.INVALID_COUNTRY
  }) || getString('APP.USERADDRESS.ERROR.COUNTRY_INVALID');
  return '';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/handleAddressUpdate.js
// module id = 4555
// module chunks = 11